import React from 'react'
import { ExclamationCircleFilled } from '@ant-design/icons'

/**
 * Câu lỗi dưới ô nhập kèm icon ⓘ đỏ đứng trước — khuôn lỗi chung của cụm "Tài khoản liên kết"
 * (Figma lỗi biểu mẫu `26:8989`, sai mật khẩu `26:9882`).
 *
 * Dùng được làm `message` của antd `rules` (antd 5 nhận `ReactElement`) lẫn render thẳng trong
 * `PasswordPromptDialog`. Icon `aria-hidden` và không có chữ ⇒ `textContent` của khối lỗi vẫn đúng
 * nguyên câu lỗi (test + e2e so từng ký tự).
 */
const FieldErrorText = ({ text }: { text: string }): JSX.Element => (
  <span className="linked-account-field-error">
    <ExclamationCircleFilled aria-hidden />
    {text}
  </span>
)

export default FieldErrorText
